import React from "react";

import { FooterLinksStreamBlock as Value } from "@reactivated";

import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

import { Clickable } from "../Clickables";
import { RichText } from "../RichText";

import styles from "./FooterLinks.module.scss";

interface Props {
    value: Value;
}

const footerLinksComponents: StreamFieldBlockMap<Value> = {
    text: ({ value }) => <RichText value={value} className={styles.richText} />,
    link: ({ value }) => (
        <Clickable simpleLink={value} className={styles.cta} />
    ),
    onetrust: ({ value }) => (
        <Clickable
            className={styles.cta}
            onClick={() => {
                // @ts-expect-error Onetrust is loaded globally and not tracked in typescript
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                Optanon.ToggleInfoDisplay();
            }}
        >
            {value}
        </Clickable>
    ),
};

export const FooterLinks = ({ value }: Props) => (
    <div className={styles.root}>
        <StreamField
            tagName={React.Fragment}
            components={footerLinksComponents}
            value={value}
        />
    </div>
);
